import { Controller } from "@hotwired/stimulus"

// Relabels a saved date in this browser's zone. The server labels in the
// viewer's zone, but a broadcast to a shared folder renders once for every
// member (#3660). Keep the ladder in step with DateLabel.saved.
export default class extends Controller {
  connect() {
    const time = new Date(this.element.getAttribute("datetime"))
    if (Number.isNaN(time.getTime())) return

    this.element.textContent = savedLabel(time, new Date())
  }
}

function localDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export function savedLabel(time, now) {
  // Rounded: a day across a DST change is 23 or 25 hours long.
  const daysAgo = Math.round((localDay(now) - localDay(time)) / 86_400_000)

  if (daysAgo <= 0) return "today"
  if (daysAgo === 1) return "yesterday"
  if (daysAgo < 7) return `${daysAgo} days ago`
  if (time.getFullYear() === now.getFullYear()) {
    return time.toLocaleDateString("en-US", { month: "short", day: "numeric" })
  }
  return String(time.getFullYear())
}
